var React = require('react');
var createReactClass = require('create-react-class');

import Post from './post.jsx';

var Posts = createReactClass({

    render() {

        // if we have a data array of posts
        if ( this.props.data.length > 0 ) {

            const posts = this.props.data.map( ( dataObject ) => {
                var excerpt = dataObject.excerpt.rendered ? this.shorten(dataObject.excerpt.rendered, 100) : '';
                
                return (

                    <Post
                        key={ dataObject.id.toString() }
                        id = { dataObject.id }
                        link = { dataObject.link }
                        title = { dataObject.title.rendered }
                        content = { excerpt }
                        type = { dataObject.categories ? dataObject.categories[0] : '' }
                        resource_type= { dataObject.resource_type ? dataObject.resource_type[0] : '' }
                        date = { dataObject.acf.publication_date }
                        posttype = { dataObject.type }
                    />

                )

            });

            return (
                <div className="row">{ posts }</div>
            )

        }
        // otherwise
        else {
            return null;
        }

    },
    
    shorten : function( str,n ) {
        return (str.match(RegExp(".{"+n+"}\\S*"))||[str])[0] + '...';
    }
});


export default Posts;